import * as React from 'react';

import { useIntl } from 'react-intl';

import { ModalBody } from '../send-gift.styled';

export const GiftSentSuccessBody = ({
  email,
  giftName,
  remainingPoints,
}: {
  email: string;
  giftName: string;
  remainingPoints?: number;
}) => {
  const { formatMessage } = useIntl();
  return (
    <ModalBody>
      <p>
        {formatMessage(
          { id: 'giftSentSuccess' },
          { email: <b>{email}</b>, gift: <b>{giftName}</b> }
        )}
      </p>
      <hr />
      <p>
        {formatMessage(
          { id: 'rewardsPointsBalanceIsNow' },
          {
            remainingPoints: (
              <>
                <br />
                <span>
                  {remainingPoints} {formatMessage({ id: 'points' })}
                </span>
              </>
            ),
          }
        )}
      </p>
    </ModalBody>
  );
};
